import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "100vw",
    marginLeft: 0,
    padding: 0,
  },
  contentContainer: {
    maxWidth: "670px",
    margin: "0 auto",
    padding: 0,
    marginTop: 40,
    border: "1px solid #D9E7F0",
    borderRadius: "16px",
  },
  needHelpContainer: {
    padding: "24px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
      opacity: "90%",
    },
    "&:a": {
      color: "inherit",
    },
  },
  needHelpContentContainer: {
    marginLeft: "15px",
  },
  termsContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: 15,
    padding: 24,
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
      opacity: "90%",
    },
  },
  sectionTitle: {
    fontSize: 16,
  },
  sectionSubTitle: {
    fontSize: 14,
  },
  title: {
    width: "auto",
    height: 60,
    fontFamily: "Inter",
    fontSize: 30,
    display: "flex",
    alignItems: "center",
    color: "#0F172A",
  },
  emailLink: {
    textDecoration: "none",
    color: "inherit",
  },
  closeButton: {
    cursor: "pointer",
  },
  policyHeaderContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  extraPadding: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 0,
  },
}));
